export default __webpack_public_path__ + "static/media/process_05.37803dae.png";